export default "__VITE_ASSET__Z_hTy62H__"